<mat-drawer-container class="container" autosize>

  <!-- Category selector (shown when no category was provided) -->
  <mat-card *ngIf="showCategorySelector" class="contrast">
    <mat-card-content>
      <h3>Select a File Vault Category</h3>
      <div fxLayout="column" fxLayoutGap="8px">
        <button *ngFor="let cat of categoryOptions" mat-flat-button color="primary" (click)="onCategorySelected(cat.value)">
          {{cat.label}}
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!showCategorySelector" class="contrast">
    <mat-card-content>
      <div fxLayout="row" fxLayoutGap="15px">
        <div class="filter" fxFlex="70">
          <mat-form-field class="accent">
              <mat-label>Search all {{ this.totalCount }} File Vault Files</mat-label>
              <input matInput type="text" name="searchTerm" placeholder="Search {{ this.totalCount }} file vault files"
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="debounceSearchTermChanged()"
                  (keyup.esc)="searchTerm=''; searchTermChanged()">
              <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; searchTermChanged()">
                  <mat-icon>close</mat-icon>
              </button>
          </mat-form-field>
        </div>

        <div fxFlex="30">

          <mat-form-field class="accent">
            <mat-label>Filter by file extension</mat-label>

            <mat-select [formControl]="fileExtensionFilter" multiple (selectionChange)="debounceSearchTermChanged()">
              <mat-select-trigger>
                {{fileExtensionFilter.value ? fileExtensionFilter.value[0] : ''}}
                <span *ngIf="fileExtensionFilter.value?.length > 1" class="example-additional-selection">
                  (+{{fileExtensionFilter.value.length - 1}} {{fileExtensionFilter.value?.length === 2 ? 'other' : 'others'}})
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let fileExtension of data.validFileExtensions" [value]="fileExtension">{{fileExtension}}</mat-option>
            </mat-select>

          </mat-form-field>



        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!showCategorySelector" class="contrast">
    <mat-card-content>
      <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-flat-button color="primary" (click)="chooseSelectFileVaultReferences()" [disabled]="getSelectedFileVaultReferenceCount() === 0">
          Select {{ pluralize("File Vault Reference", getSelectedFileVaultReferenceCount()) }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!showCategorySelector" class="contrast">
    <mat-card-content>
      <div *ngFor="let item of dataSource" fxLayout="row" fxLayoutAlign="start center">

        <button mat-icon-button color="accent" *ngIf="item.isSelected" (click)="selectFileVaultReference(item)">
          <mat-icon>check_box</mat-icon>
        </button>
        <button mat-icon-button color="accent" *ngIf="!item.isSelected" (click)="selectFileVaultReference(item)">
          <mat-icon>check_box_outline_blank</mat-icon>
        </button>
        <span>{{ item.fileName }}</span>

      </div>
    </mat-card-content>
  </mat-card>
  
</mat-drawer-container>